export default {
  histories: (state) => state.histories,
  historyList: (state) => state.histories?.list,
};
